import { render, staticRenderFns } from "./td-tradeApprove.vue?vue&type=template&id=0c238550"
import script from "./td-tradeApprove.vue?vue&type=script&lang=js"
export * from "./td-tradeApprove.vue?vue&type=script&lang=js"
import style0 from "./td-tradeApprove.vue?vue&type=style&index=0&id=0c238550&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports